import React from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';

const etapas = [
  {
    titulo: '1. Base rural',
    itens: ['Produtor Rural', 'Fazenda', 'Mapa da Fazenda', 'Talhão', 'Safra']
  },
  {
    titulo: '2. Operação no campo',
    itens: ['Plantio', 'Insumos', 'Compra de Insumos', 'Aplicações no Campo', 'Máquinas', 'Operações de Campo']
  },
  {
    titulo: '3. Produção',
    itens: ['Despesas da Safra', 'Colheita', 'Estoque Agrícola', 'Venda da Produção', 'Romaneio']
  },
  {
    titulo: '4. Fiscal e financeiro',
    itens: ['Nota Fiscal', 'CT-e / Frete', 'Contas a Pagar e Receber', 'Fluxo de Caixa']
  },
  {
    titulo: '5. Gestao',
    itens: ['Fechamento da Safra', 'Relatórios', 'Painel', 'Pecuária']
  }
];

const regras = [
  'Plantio sempre pertence a um talhão e a uma safra.',
  'Aplicação no campo baixa insumo do estoque.',
  'Compra de insumo aumenta estoque e pode gerar conta a pagar.',
  'Colheita aumenta estoque agrícola.',
  'Venda reduz estoque agrícola, gera financeiro e pode emitir nota fiscal.',
  'CT-e registra o frete vinculado ao transporte.',
  'Toda despesa vinculada entra no custo da safra.',
  'Fechamento mostra custo, receita, produtividade e lucro.'
];

const fluxoBadgeStyle = {
  background: '#123f2a',
  color: '#f4fff8',
  border: '1px solid #45c07a',
  boxShadow: '0 1px 0 rgba(255,255,255,0.08) inset',
  fontWeight: 700
};

const fluxoArrowStyle = {
  color: '#8ee8c3',
  fontSize: '1.1rem'
};

const headerBadgeStyle = {
  background: '#0f2f23',
  color: '#f4fff8',
  border: '1px solid rgba(255,255,255,0.35)',
  boxShadow: '0 1px 0 rgba(255,255,255,0.12) inset',
  fontWeight: 700
};

function FluxoErp() {
  return (
    <div className="d-flex" style={{ minHeight: '100vh' }}>
      <Sidebar />
      <div className="flex-grow-1">
        <Header />
        <div className="container-fluid py-4">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
              <div>
                <h5 className="mb-1 fw-bold">Fluxo do ERP Agro</h5>
                <small className="text-white-50">Consulta rápida para entender como os módulos conversam</small>
              </div>
              <span className="badge" style={headerBadgeStyle}>Do plantio ao lucro</span>
            </div>
            <div className="card-body">
              <div className="row g-3">
                {etapas.map((grupo) => (
                  <div className="col-12 col-lg" key={grupo.titulo}>
                    <div className="border rounded-3 p-3 h-100">
                      <div className="fw-semibold text-success mb-3">{grupo.titulo}</div>
                      <div className="d-grid gap-2">
                        {grupo.itens.map((item) => (
                          <div className="border rounded-3 px-3 py-2" key={item}>
                            {item}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row g-4 mt-1">
                <div className="col-12 col-xl-7">
                  <div className="card border-0 bg-transparent">
                    <div className="card-header bg-white fw-semibold">Fluxo principal</div>
                    <div className="card-body px-0">
                      <div className="d-flex flex-wrap align-items-center gap-2">
                        {['Produtor', 'Fazenda', 'Mapa', 'Talhão', 'Safra', 'Plantio', 'Insumos', 'Despesas', 'Colheita', 'Estoque', 'Venda', 'Nota Fiscal', 'CT-e', 'Financeiro', 'Relatórios'].map((step, index) => (
                          <React.Fragment key={step}>
                            <span className="badge p-2" style={fluxoBadgeStyle}>
                              {index + 1}. {step}
                            </span>
                            {index < 14 && <i className="bi bi-arrow-right" style={fluxoArrowStyle} />}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-5">
                  <div className="card border-0 bg-transparent">
                    <div className="card-header bg-white fw-semibold">Regras que amarram o sistema</div>
                    <div className="card-body px-0">
                      <div className="d-grid gap-2">
                        {regras.map((regra) => (
                          <div className="border rounded-3 px-3 py-2 d-flex gap-2" key={regra}>
                            <i className="bi bi-check-circle-fill text-success" />
                            <span>{regra}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FluxoErp;
